import React from "react";
import FAQ from '../../Pages/FAQ/FAQ';
import JwtComponent from "../JwtComponent";
import ConfirmEmail from '../ConfirmEmail';
import Tickets from '../../Pages/Tickets/Tickets';
import Profile from '../../Pages/Profile/Profile';
import NotFound from "../../Pages/NotFound/NotFound";
import AddTicket from '../../Pages/Tickets/AddTicket';
import Incident from '../../Pages/Incidents/Incidents';
import Dashboard from '../../Pages/Dashboard/Dashboard';
import AddIncident from '../../Pages/Incidents/AddIncident';
import RecurringTickets from '../../Pages/Tickets/RecurringTickets';
import AddSubTicket from "../../Pages/Tickets/SubTicket/AddSubTicket";
import TicketCalendar from '../../Pages/TicketCalendar/TicketCalendar';
import PR from "../../Pages/Procurements/PruchaseOrder/PurchaseOrders/PR";
import RFP from "../../Pages/Procurements/PruchaseOrder/PurchaseOrders/RFP";
import RFQ from "../../Pages/Procurements/PruchaseOrder/PurchaseOrders/RFQ";
import ApprovalPerson from '../../Pages/Settings/Procurements/ApprovalPerson';
import PurchaseOrderTypes from '../../Pages/Settings/Procurements/PurchaseOrderTypes';
import AddDocumentTemplate from "../../Pages/Settings/General/DocumentTemplates/AddDocumentTemplate";
import PurchaseOrders from '../../Pages/Procurements/PruchaseOrder/PurchaseOrders/PurchaseOrders';
import PendingRequests from '../../Pages/Procurements/PruchaseOrder/ApprovalRequests/PendingRequests';
import AddPurchaseOrder from '../../Pages/Procurements/PruchaseOrder/PurchaseOrders/Components/AddPurchaseOrder';
import { Route } from "react-router-dom";
import { EndPoints } from "../../../utils/apiEndpoints";
import { AuthenticatedAdminRoutes } from './AuthenticatedAdminRoutes';
import DocumentTemplates from "../../Pages/Settings/General/DocumentTemplates/DocumentTemplates";

const {
    RESETPASSWORD, ANALYTICS, TICKETS, INCIDENTS, PROFILE,
    PURCHASEORDERS, ADDPURCHASEORDER, PENDINGREQUESTS, ADDINCIDENT,
    TICKETCALENDARS, PURCHASEORDERTYPES, APPROVALPERSONS, FAQ: FAQROUTE,
    CONFIRMEMAIL, RECURRINGTICKETS, JWTAPI, SUBTICKET, REQUESTFORPROPOSAL,
    REQUESTFORQUOTATION, PURCHASEREQUESTS, DOCUMENTTEMPLATE, ADDDOCUMENTTEMPLATE,
    ADDTICKET,
} = EndPoints;

interface AuthenticatedRoutesProps {
    isAdminRole: boolean;
    canAddTickets: boolean;
    pathname: string;
}

const AuthenticatedRoutes = ({ isAdminRole, canAddTickets, pathname }: AuthenticatedRoutesProps) => {
    const simpleRoutes = [
        { path: '/', element: <Dashboard /> },
        { path: RESETPASSWORD, element: <Dashboard /> },
        { path: ANALYTICS, element: <Dashboard /> },
        { path: JWTAPI, element: <JwtComponent /> },
        { path: CONFIRMEMAIL, element: <ConfirmEmail /> },
        { path: TICKETS, element: <Tickets /> },
        { path: RECURRINGTICKETS, element: <RecurringTickets /> },
        { path: INCIDENTS, element: <Incident /> },
        { path: ADDINCIDENT, element: <AddIncident /> },
        { path: FAQROUTE, element: <FAQ /> },
        { path: PROFILE, element: <Profile /> },
        { path: TICKETCALENDARS, element: <TicketCalendar /> },
        { path: PURCHASEORDERS, element: <PurchaseOrders /> },
        { path: ADDPURCHASEORDER, element: <AddPurchaseOrder mode="Add" /> },
        { path: PENDINGREQUESTS, element: <PendingRequests /> },
        { path: PURCHASEORDERTYPES, element: <PurchaseOrderTypes /> },
        { path: APPROVALPERSONS, element: <ApprovalPerson /> },
        { path: PURCHASEREQUESTS, element: <PR /> },
        { path: REQUESTFORPROPOSAL, element: <RFP /> },
        { path: REQUESTFORQUOTATION, element: <RFQ /> },
        { path: DOCUMENTTEMPLATE, element: <DocumentTemplates /> },
        { path: ADDDOCUMENTTEMPLATE, element: <AddDocumentTemplate mode="Add" /> },
    ];

    const dynamicRoutes = [
        // Tickets
        { path: `${TICKETS}/edit/:id/:readFeedback?`, element: <AddTicket /> },
        { path: `${TICKETS}/view/:id`, element: <AddTicket view /> },
        // SubTickets
        { path: `${TICKETS}/:id${SUBTICKET}/add`, element: <AddSubTicket /> },
        { path: `${TICKETS}/edit/:id${SUBTICKET}/:subticketId`, element: <AddSubTicket /> },
        { path: `${TICKETS}/view/:id${SUBTICKET}/:subticketId`, element: <AddSubTicket view /> },
        // Recurring Tickets
        { path: `${RECURRINGTICKETS}/edit/:id/:readFeedback?`, element: <AddTicket isRecurringTicket /> },
        { path: `${RECURRINGTICKETS}/view/:id`, element: <AddTicket view isRecurringTicket /> },
        // Incidents
        { path: `${INCIDENTS}/edit/:id`, element: <AddIncident /> },
        { path: `${INCIDENTS}/view/:id`, element: <AddIncident view /> },
        // Purchase Orders
        { path: `${PURCHASEORDERS}/edit/:id`, element: <AddPurchaseOrder mode="Edit" /> },
        { path: `${PURCHASEORDERS}/view/:id`, element: <AddPurchaseOrder mode="View" /> },
        //DocumentTemplate
        { path: `${DOCUMENTTEMPLATE}/edit/:id`, element: <AddDocumentTemplate mode='Edit' /> },
        { path: `${DOCUMENTTEMPLATE}/view/:id`, element: <AddDocumentTemplate mode='View' /> },
    ];

    return (
        <>
            {simpleRoutes.map(({ path, element }, i) => (
                <Route key={i} path={path} element={element} />
            ))}

            {dynamicRoutes.map(({ path, element }, i) => (
                <Route key={`dynamic-${i}`} path={path} element={element} />
            ))}

            {canAddTickets && <Route path={ADDTICKET} element={<AddTicket />} />}
            {isAdminRole && AuthenticatedAdminRoutes()}

            {pathname !== '/login' && <Route path="*" element={<NotFound />} />}
        </>
    );
};

export default AuthenticatedRoutes;
